import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeC from '../components/HomeComponent.vue'
import Project from '../components/ProjectComponent.vue'
import Fitty from 'vue-fitty'

Vue.use(VueRouter)
Vue.use(Fitty);

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeC
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../components/AboutComponent.vue')
  },
  {
    path: "/project/:project",
    name: "project",
    props: true,
    children: [
      {
        path: ':/project',
        props: true,
        component: Project
      }
    ],
    component: () => import("../components/ProjectComponent.vue"),

  }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes
})
// router.beforeEach((to, from, next) => {
//   window.onpopstate = function(event) {
//   // alert("location: " + document.location + ", state: " + JSON.stringify(event.state))
//     let x = event;
//     console.log(x);
//     window.backbuttonPressed = true;
//     next()
//   };

//   next();
// })


export default router
